__turbopack_context__.v({
  "current": "hwYh-q_current",
  "item": "hwYh-q_item",
  "link": "hwYh-q_link",
  "list": "hwYh-q_list",
  "nav": "hwYh-q_nav",
  "navChannel": "hwYh-q_navChannel",
  "navDark": "hwYh-q_navDark",
  "separator": "hwYh-q_separator",
  "text": "hwYh-q_text",
});
